import { DoubleSide, LineBasicMaterial, MeshBasicMaterial, MeshStandardMaterial } from 'three'

export const ThreeItemKeys = {
  AREA_TYPE: 'c3dAreaType',
  ASSIGNED_GROUP_ID: 'c3dAssignedGroupId',
  ASSIGNED_PRINTER_ID: 'c3dAssignedPrinterId',
  AVOID_INSIDE_TRAVELLING: 'c3dAvoidInsideTravelling',
  AVOID_INSIDE_TRAVELLING_MARGIN_MM: 'c3dAvoidInsideTravellingMarginMm',
  FILE_ID: 'c3dFileId',
  FILE_NAME: 'c3dFileName',
  FORBIDDEN_ZONE_HEIGHT: 'c3dForbiddenZoneHeight',
  FORBIDDEN_ZONE_POINTS: 'c3dForbiddenZonePoints',
  GRID_TYPE: 'c3dGridType',
  GROUP_ID: 'c3dGroupId',
  GROUP_NAME: 'c3dGroupName',
  INVERT_PRINT_DIRECTION: 'c3dInvertPrintDirection',
  ORIGINAL_FILE_TYPE: 'c3dOriginalFileType',
  ICP_COORDINATES: 'c3dIcpCoordinates',
  ICP_FILE_NAME: 'c3dIcpFileName',
  IS_ORIGINAL_DXF: 'c3dIsOriginalDxf',
  ITEM_TYPE: 'c3dSlicingType',
  LAYER_HEIGHT: 'c3dLayerHeight',
  LAYERS_AMOUNT: 'c3dLayersAmount',
  LAYERS_GROUP_AMOUNT: 'c3dLayersGroupAmount',
  LOCKED: 'c3dLocked',
  ORIGINAL_FILE_NAME: 'c3dOriginalFilename',
  PARENT_GROUP_ID: 'c3dParentGroupId',
  PREFERRED_PRINTER: 'c3dPreferredPrinter',
  PRINTER_BOOM: 'c3dPrinterBoom',
  PRINTER_COLOR: 'c3dPrinterColor',
  PRINTER_HEIGHT: 'c3dPrinterHeight',
  PRINTER_ID: 'c3dPrinterId',
  PRINTER_JIB: 'c3dPrinterJib',
  PRINTER_MODEL: 'c3dPrinterModel',
  PRINTER_OPTIONS: 'c3dPrinterOptions',
  PRINTER_NEXT_INDEX: 'c3dPrinterNextIndex',
  PRINTING_ORDER: 'c3dPrintingOrder',
  PRINTING_SPIRAL_MODE: 'c3dSpiralMode',
  ROTATION_LOCKED_X: 'c3dRotationLockedX',
  ROTATION_LOCKED_Y: 'c3dRotationLockedY',
  ROTATION_LOCKED_Z: 'c3dRotationLockedZ',
  SEAM: 'c3dSeamPosition',
  TRANSIENT: 'c3dTransient',
  TRANSLATION_LOCKED_X: 'c3dTranslationLockedX',
  TRANSLATION_LOCKED_Y: 'c3dTranslationLockedY',
  TRANSLATION_LOCKED_Z: 'c3dTranslationLockedZ',
}

export const ThreeItemTypes = {
  CARTESIAN_ZONE: 'cartesianZone',
  FILE: 'file',
  FORBIDDEN_ZONE: 'forbiddenZone',
  GROUP: 'group',
  OPTION_CONSTRAINT_ZONE: 'optionConstraintZone',
  INNER_ZONE_RING: 'innerZoneRing',
  LIGHTS: 'lights',
  OUTER_ZONE_RING: 'outerZoneRing',
  POLAR_ZONE: 'polarZone',
  PRINTABLE_ZONE: 'printableZone',
  PRINTER_MESH: 'printerMesh',
  PRINTER: 'printer',
  SEAM: 'seam',
  SEAM_MARKER: 'seamMarker',
  SEAM_LINE: 'seamLine',
}

export const ThreeOriginalFileTypes = {
  DXF_2D: 'dxf/2d',
  DXF_3D: 'dxf/3d',
  MPP: 'mpp',
  MXP: 'mxp',
  OBJ: 'obj',
  STEP: 'step',
  STL: 'stl',
  THREEMF: '3mf',
}

export const ThreeSpiralModes = {
  SEMI_SPIRAL: 'semiSpiral',
  SPIRAL: 'spiral',
  OFF: 'off',
}

export const forbiddenZoneMaterial = new MeshStandardMaterial({
  name: 'ForbiddenZoneMaterial',
  color: 'red',
  opacity: 0.75,
  transparent: true,
})
export const forbiddenZoneWireframeMaterial = new MeshStandardMaterial({
  name: 'ForbiddenZoneWireframeMaterial',
  color: 'red',
  wireframe: true,
})
export const gcodePreviewG0LineMaterial = new LineBasicMaterial({
  name: 'GcodePreviewG0LineMaterial',
  color: 'red',
})
export const gcodePreviewG1LineMaterial = new LineBasicMaterial({
  name: 'GcodePreviewG1LineMaterial',
  color: 'blue',
})
export const gcodePreviewCurrentPointMaterial = new MeshStandardMaterial({
  name: 'GcodePreviewCurrentPointMaterial',
  color: 'red',
})
export const defaultLineMaterial = new LineBasicMaterial({
  color: 'lightgray',
  name: 'DefaultLineMaterial',
})
export const defaultMeshMaterial = new MeshStandardMaterial({
  name: 'DefaultMeshMaterial',
  color: 'lightgray',
  roughness: 0.5,
  metalness: 0.1,
  side: DoubleSide,
})
export const seamAccentColor = 0xE68E00
export const seamLineMaterial = new MeshStandardMaterial({
  name: 'SeamLineMaterial',
  color: seamAccentColor,
  roughness: 0.5,
  metalness: 0.3,
  emissive: seamAccentColor,
  emissiveIntensity: 0.12,
  polygonOffset: true,
  polygonOffsetFactor: -2,
  polygonOffsetUnits: -2,
})
export const seamMarkerMaterial = new MeshStandardMaterial({
  name: 'SeamMarkerMaterial',
  color: seamAccentColor,
  roughness: 0.2,
  metalness: 0.6,
  emissive: seamAccentColor,
  emissiveIntensity: 0.3,
  polygonOffset: true,
  polygonOffsetFactor: -4,
  polygonOffsetUnits: -4,
})
export const seamMarkerHaloMaterial = new MeshBasicMaterial({
  name: 'SeamMarkerHaloMaterial',
  color: seamAccentColor,
  transparent: true,
  opacity: 0.22,
  depthWrite: false,
})
